import { useState } from 'react';
import { Button, Toast, ToastContainer } from 'react-bootstrap';
import SupplierList from '../components/SupplierList';
import CreateSupplierModal from '../components/CreateSupplierModal';
import type { UserOrganisation } from '../types/types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { gToastPosition, gToastSentiment } from '../util/constst';

export default function Suppliers() {
  const [showCreateModal, setShowCreateModal] = useState(false);

  const [reloadKey, setReloadKey] = useState(0);
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();

  const selectedOrganisation = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.organisation.selected,
  ) as UserOrganisation | undefined;

  const handleCreated = () => {
    setReloadKey((prev) => prev + 1); // trigger reload
    // setShowCreateModal(false);
  };

  const handleFinished = () => {
    setShowCreateModal(false);
    setShowToast(true);
  };

  return (
    <div>
      {selectedOrganisation && (
        <h2 className="mb-3">
          Suppliers for {selectedOrganisation?.organisation?.name}
        </h2>
      )}
      <div className="mb-3">
        <Button variant="primary" onClick={() => setShowCreateModal(true)}>
          Add Supplier
        </Button>
        <Button
          variant="outline-primary"
          className="ms-2"
          onClick={() => {
            // navigate to bulk-import-suppliers page using router
            navigate('bulk-import-suppliers');
          }}
        >
          Import Suppliers
        </Button>
      </div>

      <SupplierList reloadKey={reloadKey} />

      <CreateSupplierModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        onCreated={handleCreated}
        onFinished={handleFinished}
      />

      {/* Toast notification */}
      <ToastContainer position={gToastPosition} className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg={gToastSentiment}
        >
          <Toast.Body>Supplier was created successfully 🎉</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
